module.exports = __webpack_public_path__ + "img/home_sj_s_icon.46e8ace.png";